
function Header(){
    return(
        <div className="header">
            <h1>Technical Writing Prompts</h1>
            <p> The hardest part of writing is coming up with a concept idea, not anymore! <br />
            Enter your preferred language in the search bar bellow and find fitting writing prompts according to what you're looking.</p>
        </div>
        
    )
}

export default Header;